import { parseScriptOptions } from './config';
import { initConsentWidget } from './widget';
import type { ConsentWidgetApi, ConsentWidgetOptions } from './types';

declare global {
  interface Window {
    GDConsent?: ConsentWidgetApi;
    GDConsentWidgetConfig?: ConsentWidgetOptions;
  }
}

const autoInit = (): void => {
  if (typeof document === 'undefined') return;
  const script = document.currentScript;
  if (!(script instanceof HTMLScriptElement) || script.dataset.manual === 'true') return;

  const scriptOptions = Object.fromEntries(
    Object.entries(parseScriptOptions(script)).filter(([, value]) => value !== undefined),
  ) as ConsentWidgetOptions;

  initConsentWidget({
    ...(window.GDConsentWidgetConfig ?? {}),
    ...scriptOptions,
  });
};

autoInit();

export { initConsentWidget } from './widget';
export {
  createAcceptedChoices,
  createDefaultGoogleConsent,
  createDeniedChoices,
  normalizeChoices,
  toGoogleConsent,
} from './consent';
export type {
  ConsentChoices,
  ConsentEventDetail,
  ConsentWidgetApi,
  ConsentWidgetOptions,
  GoogleConsentState,
  OptionalCategoryKey,
} from './types';
